import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const shortcuts = [
  { to: '/guide/fleet', label: 'nav.items.fleet', icon: 'fleet' },
  { to: '/guide/seats', label: 'nav.items.seats', icon: 'seats' },
  { to: '/destinations/domestic', label: 'nav.items.domestic', icon: 'domestic' },
  { to: '/destinations/international', label: 'nav.items.international', icon: 'international' },
] as const;

export function HomeShortcuts() {
  const { t } = useTranslation();

  return (
    <section className="home-shortcuts" aria-label={t('nav.groups.inflight')}>
      <div className="sa-container">
        <ul className="home-shortcuts__grid">
          {shortcuts.map((item) => (
            <li key={item.to}>
              <Link className="home-shortcut" to={item.to}>
                <span className="home-shortcut__icon" aria-hidden="true">
                  <img
                    className="home-shortcut__img"
                    src={`/images/shortcuts/${item.icon}.png`}
                    alt=""
                    width={256}
                    height={256}
                    loading="lazy"
                    decoding="async"
                  />
                </span>
                <span className="home-shortcut__label">{t(item.label)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
